import React, { useEffect } from 'react';
import { getReturnToUrl } from 'src/dataLayer/localData/queryParams';
import { Spinner } from '@lessonnine/design-system.lib';

/*
 * Used as the default redirect handler for authenticated
 * pages. Does not create a history item.
 */

export default function AuthenticatedRedirect() {
  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      window.location.replace(getReturnToUrl(window.location.search, false));
    }, 2000);

    return () => clearTimeout(timeoutRef);
  }, []);

  return (<Spinner data-testid="babbel-spinner" size={42} />);
};
